<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs :pt-5="$vuetify.breakpoint.lgAndUp">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row wrap justify-center align-center pt-5 pb-10>
            <v-flex xs12 lg10>
              <v-card class="rounded-lg pt-7">
                <center>
                  <img
                    class="logo-cmp"
                    :src="require('@/assets/img/logoINETCMP.png')"
                    width="400"
                    alt=""
                  />
                </center>
                <v-card-text class="black--text" style="font-size: 16px">
                  <v-layout row wrap justify-center align-center pa-1>
                    <v-flex xs12 lg11>
                      <p class="pt-5"><b>หมายเลขนโยบาย : </b> {{ PolicyId }}</p>

                      <v-card outlined>
                        <v-card-text
                          class="black--text"
                          style="font-size: 16px"
                        >
                          <p>
                            <b class="pb-2" style="font-size: 22px"
                              >รายละเอียดนโยบาย
                            </b>
                          </p>
                          <p><b>สร้างโดย : </b> {{ UpdatdeBy }}</p>
                          <p><b>องค์กร : </b> {{ BusinessNameTh }}</p>
                          <p><b>วันที่สร้างนโยบาย : </b> {{ UpdatdeAt }}</p>
                          <v-card class="ma-3" outlined color="grey lighten-4">
                            <v-container>
                              <v-card-title primary-title>
                                {{ Title }} <v-spacer></v-spacer>
                              </v-card-title>
                              <v-divider></v-divider>
                              <v-card-text>
                                <v-layout row wrap ml-3 pa-1>
                                  <v-flex xs11 lg11>
                                    <div v-html="Details"></div>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                            </v-container>
                          </v-card>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    justify-center
                    align-center
                    pt-4
                    pb-7
                    v-if="NameBtnSave == 'อนุมัตินโยบาย'"
                  >
                    <v-flex xs7 sm7 md2 lg2>
                      <v-btn
                        :loading="load"
                        color="#077893"
                        dark
                        block
                        @click="Fn_Save"
                      >
                        {{ NameBtnSave }}</v-btn
                      >
                    </v-flex>
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    justify-center
                    align-self-center
                    pb-4
                    v-else
                  >
                    <v-flex xs12 lg4 pt-4>
                      <v-alert border="left" dense text type="success">
                        {{ NameBtnSave }}
                      </v-alert>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { OverlaySearch },
  data: function () {
    return {
      load: false,
      loadingDownloadData: false,
      valid: true,
      DataPolicy: [],
      ChatAccountId: "",
      AccountId: "",
      PolicyId: "",
      BusinessNameTh: "",
      Title: "",
      Details: "",
      UpdatdeBy: "",
      UpdatdeAt: "",
      Manage: "",
      NameBtnSave: "อนุมัตินโยบาย",
      ShowStatus: true,
    };
  },
  computed: {
    // ...mapGetters(["DataGroupConsent"]),
    // ...mapGetters(["Business"]),
    // ...mapGetters(["RoleAccount"]),
    // _RoleAccount: {
    //   get() {
    //     return this.RoleAccount || "-";
    //   },
    // },
    // _SendId: {
    //   get() {
    //     return this.DataGroupConsent.SendId || "-";
    //   },
    // },
  },
  mounted() {
    this.Fn_GetToken();
  },
  methods: {
    async Fn_GetToken() {
      this.loadingDownloadData = true;
      var payload = {
        ShareToken: this.$route.path.split("/")[4],
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "token/login",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.AccessToken = response.data.Message.OneAccessToken;
            this.ChatAccountId = response.data.Message.OneAccountId;
            this.$cookies.set(
              "ChatAccountId",
              response.data.Message.OneAccountId
            );
            this.Fn_getDataPolicy();
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_getDataPolicy() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$route.path.split("/")[2],
        PolicyId: this.$route.path.split("/")[3],
        AccessToken: this.AccessToken,
      };
      var Headers = {
        AccountId: this.ChatAccountId,
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "policy/GetPolicy",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.DataPolicy = response.data.Message;
            this.PolicyId = this.DataPolicy[0].PolicyId;
            this.AccountId = this.DataPolicy[0].AccountId;
            this.BusinessNameTh = this.DataPolicy[0].BusinessNameTh;
            this.Title = this.DataPolicy[0].Title;
            this.Details = this.DataPolicy[0].Details;
            this.UpdatdeBy = this.DataPolicy[0].UpdatdeBy;
            this.UpdatdeAt = this.DataPolicy[0].UpdatdeAt;
            this.Manage = this.DataPolicy[0].Manage;
            if (this.Manage == "enable") {
              this.NameBtnSave = "นโยบายนี้ได้ทำการอนุมัติเรียบร้อยแล้ว";
              this.ShowStatus = false;
            } else {
              this.NameBtnSave = "อนุมัตินโยบาย";
              this.ShowStatus = true;
            }
          } else {
            window.close();
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          window.close();
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Save() {
      this.load = true;
      var payload = {
        AccessToken: this.AccessToken,
        BusinessId: this.$route.path.split("/")[2],
        PolicyId: this.$route.path.split("/")[3],
        AccountId: this.AccountId,
        Title: this.Title,
        Details: this.Details,
        Manage: "enable",
      };

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "policy/UpdateDetailPolicy",
          payload
        )
        .then((response) => {
          this.load = false;
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.NameBtnSave = "คุณได้อนุมัตินโยบายเรียบร้อยแล้ว";
            this.ShowStatus = false;
            this.Fn_getDataPolicy();
            Toast.fire({
              icon: "success",
              title: "อนุมัตินโยบายสำเร็จ",
            });
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.load = false;
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Cancle() {
      window.close();
      this.$refs.formData.reset();
    },
  },
  watch: {},
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.bg-card {
  background-color: #eeeeee;
}
</style>
